export function formatNumberToShort(value: any, float = false): string {
  if (isNaN(value)) {
    return float ? '0.00' : '0';
  }

  const numValue = Number(value);

  if (Math.abs(numValue) < 1_000_000) {
    return numValue.toFixed(float ? 2 : 0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else if (Math.abs(numValue) < 100_000_000) {
    return Math.round(numValue).toLocaleString();
  } else if (Math.abs(numValue) < 1_000_000_000) {
    return `${(numValue / 1_000_000).toFixed(1)}M`;
  } else {
    return `${(numValue / 1_000_000_000).toFixed(3)}B`;
  }
}
